export class AssertionError extends Error {
}
export function assert(value, message) {
    if (!value) {
        throw new AssertionError(message ?? `Assertion failed (got ${value})`);
    }
}
//# sourceMappingURL=assert.js.map